if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.productHandle = this.dataset.productHandle;
        this.title = this.dataset.title;
        this.recentlyViewed = [];
        this.filteredProducts = [];
    }

    connectedCallback() {
      this.updateLocalStorage();
      if (!this.recentlyViewed) return;

      this.populateRecentlyViewed();
    }

    async populateRecentlyViewed() {                
      for (let i = 0; i < this.recentlyViewed?.length; i++) {
        const productHandle = this.recentlyViewed[i];
        if (i > 8 || !productHandle) break;
        
        if (productHandle !== this.productHandle) {
          await fetch(`/products/${productHandle}.json`)
            .then((response) => {
              if (!response.ok) return;
              return response.json();
            })
            .then((data) => {
              const product = data?.product;
              if (!product) return;
              const tags = product.tags.split(',').map(item => item.trim())
              const bannedtags = ['base-product', 'hide_product']
                          
              if (!bannedtags.some(i => tags.includes(i))) this.filteredProducts.push(product.handle);
            })
            .catch((err) => console.error(`Recently Viewed Products Module: ${err}`));
        }
      }
      
      if (!this.filteredProducts.length) {
        this.closest('.shopify-section')?.remove();
        return;
      }

      this.innerHTML = `
        <swiper-carousel
            data-space-between="6"
            data-slides-per-scroll="1"
            data-slides-per-view="4"
            data-mobile-slides-per-view="1.5"
            class="block w-full"
            aria-label="carousel"
        >
            
            <div class="flex items-center pb-10">
                ${this.title ? `<h2 class="text-2xl pb-10 font-body font-medium">${this.title}</h2>` : ''}
                <div class="md:flex ml-auto gap-[30px] hidden">
                    <button class="disabled:opacity-20 md:hover:enabled:text-accent1" aria-label="previous slide" data-prev>
                        <span class="block w-5 h-4 transform rotate-180"> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 14">
                                <defs>
                                    <clipPath id="y6rs0ogsua">
                                        <path data-name="Rectangle 21" d="M0 0h20v14H0z"/>
                                    </clipPath>
                                </defs>
                                <path fill="currentColor" data-name="Path 11" d="M19.647 5.872 14.047 0l-1.7 1.779L15.9 5.5H0v2.52h15.9l-3.55 3.724 1.7 1.779 5.6-5.872a1.3 1.3 0 0 0 0-1.779" transform="translate(0 .477)" style="clip-path:url(#y6rs0ogsua)"/>
                            </svg>
                        </span>
                    </button>
                    <button class="disabled:opacity-20 md:hover:enabled:text-accent1" aria-label="next slide" data-next>
                        <span class="block w-5 h-4"> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 14">
                                <defs>
                                    <clipPath id="y6rs0ogsua">
                                        <path data-name="Rectangle 21" d="M0 0h20v14H0z"/>
                                    </clipPath>
                                </defs>
                                <path fill="currentColor" data-name="Path 11" d="M19.647 5.872 14.047 0l-1.7 1.779L15.9 5.5H0v2.52h15.9l-3.55 3.724 1.7 1.779 5.6-5.872a1.3 1.3 0 0 0 0-1.779" transform="translate(0 .477)" style="clip-path:url(#y6rs0ogsua)"/>
                            </svg>
                        </span>
                    </button>
                </div>
            </div>
            <a href="#rp-end-of-carousel" tabindex="0" class="skip-carousel">Skip carousel</a>
            <div class="swiper-wrapper">
                ${this.filteredProducts.slice(0, 8).map((product) => `
                    <div class="swiper-slide aspect-[4/5] swiper-slide-visible swiper-slide-active" role="group" aria-label="1 / 7" style="width: 331px; margin-right: 4px;">
                      <intersection-loader 
                        data-url="/products/${product}" 
                        data-section-id="product-tile"
                      ></intersection-loader>  
                    </div>
                `).join('')}                                
            </div>
        </swiper-carousel>
        <span id="rv-end-of-carousel"></span>
      `;
    }

    updateLocalStorage() {
      if (localStorage.getItem('recentlyViewedProducts')) {
        this.recentlyViewed = [...new Set([...localStorage.getItem('recentlyViewedProducts')?.split(',')])].slice(0, 8) ?? [];
      }

      if ((this.recentlyViewed[this.productHandle]) || !this.productHandle) return;
      localStorage.setItem('recentlyViewedProducts', `${this.productHandle}${this.recentlyViewed ? `,${this.recentlyViewed}` : ''}`);
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}